import { AI_DISCLAIMER } from '@/shared/beta-announcement/content'

/**
 * Beta disclaimer shown under the Noah composer.
 *
 * One component for both the live composer and `AIRailPanelSkeleton`, so the
 * skeleton reserves the same height and shows the same words — the panel does
 * not shift or flash different copy when the real composer mounts.
 */
export function AskNoahDisclaimer() {
	return (
		<p className="text-muted-foreground my-2 text-center text-sm">
			<strong>{AI_DISCLAIMER.lead}</strong> {AI_DISCLAIMER.askNoah}
		</p>
	)
}
